import React from 'react';

import styles from '../styles.module.less';

type TemplateCustomizationValues = {
  title: string;
  weddingWebsiteSlug?: string;
  weddingWebsiteText: string;
  superLinkSlug?: string;
  superLinkText: string;
  titleColor: string;
  websiteColor: string;
  superLinkColor: string;
  bgColor: string;
};

const DSTDEmailPreview = ({
  title,
  weddingWebsiteSlug,
  weddingWebsiteText,
  superLinkSlug,
  superLinkText,
  titleColor,
  websiteColor,
  superLinkColor,
  bgColor,
}: TemplateCustomizationValues): JSX.Element => {
  const bgColorStyles = {
    backgroundColor: `#${bgColor}40`,
  };

  return (
    <div className={styles.templatePreview}>
      <div className={styles.templatePreviewImage} style={bgColorStyles}>
        <img
          src="https://stage-images.zola.com/6e98f3fb-34bc-4283-9d7c-bf11d30a6488"
          alt="Zola - Digital Save The Date"
        />
      </div>

      <div className={styles.templatePreviewText}>
        <h1
          className={styles.emailReset}
          style={{ color: `#${titleColor}`, whiteSpace: 'pre-wrap' }}
        >
          {title}
        </h1>
        <br />

        {superLinkSlug && (
          <div className={styles.templatePreviewSpacer}>
            <p
              className={styles.emailReset}
              style={{ color: `#${superLinkColor}`, whiteSpace: 'pre-wrap' }}
            >
              {superLinkText}
            </p>
            <a className={styles.emailReset} href={`https://www.zola.com/wedding/${superLinkSlug}`}>
              Superlink
            </a>
            <br />
          </div>
        )}

        {weddingWebsiteSlug && (
          <>
            <p
              className={styles.emailReset}
              style={{ color: `#${websiteColor}`, whiteSpace: 'pre-wrap' }}
            >
              {weddingWebsiteText}
            </p>
            <a
              className={styles.emailReset}
              href={`https://www.zola.com/wedding/${weddingWebsiteSlug}`}
            >
              Wedding website
            </a>
            <br />
          </>
        )}
      </div>
    </div>
  );
};

export default DSTDEmailPreview;
